"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiscellaneousTests = void 0;
var start_value_8_30pm_1 = require("./start-value-8.30pm");
var utils_1 = require("../../support/utils");
var is_monospace_font_1 = require("./is-monospace-font");
var MiscellaneousTests = /** @class */ (function (_super) {
    __extends(MiscellaneousTests, _super);
    function MiscellaneousTests(utils) {
        var _this = _super.call(this, utils) || this;
        _this.startTime = function () { return (0, start_value_8_30pm_1.startTime)(utils); };
        _this.isMonoSpace = function () { return (0, is_monospace_font_1.isMonoSpaceFont)(utils); };
        return _this;
    }
    return MiscellaneousTests;
}(utils_1.TestSuite));
exports.MiscellaneousTests = MiscellaneousTests;
